module.exports = __webpack_public_path__ + "static/media/vladimir_novick.a6823027.jpg";